function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("symbol", {
  id: "hha_logo_svg__a",
  viewBox: "-155.9 -56.7 311.8 113.4"
}, React.createElement("path", {
  d: "M125.5 10.7L103-56 80.5 10.7l-4 11.8L65 56.7H50.1L88.4-56.7h29.2l38.3 113.4H141l-11.5-34.2zM-155.9-56.7h14.1V56.7h-14.1zM-87.9-56.7h14.1V56.7h-14.1zM-52.9-56.7h14.1V56.7h-14.1zM15.1-56.7h14.1V56.7H15.1z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#hha_logo_svg__a",
  width: 311.8,
  height: 113.4,
  x: -155.9,
  y: -56.7,
  transform: "translate(155.905 56.695)",
  overflow: "visible"
});

var SvgHhaLogo = function SvgHhaLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 311.8 113.4"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTEuOCAxMTMuNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzExLjggMTEzLjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN5bWJvbCAgaWQ9IkhIQV9CaWxkbWFya2VfU2Nod2Fyel9SR0ItMiIgdmlld0JveD0iLTE1NS45IC01Ni43IDMxMS44IDExMy40Ij4KCTxwb2x5Z29uIHBvaW50cz0iMTI1LjUsMTAuNyAxMDMsLTU2IDgwLjUsMTAuNyA3Ni41LDIyLjUgNjUsNTYuNyA1MC4xLDU2LjcgODguNCwtNTYuNyAxMTcuNiwtNTYuNyAxNTUuOSw1Ni43IDE0MSw1Ni43IAoJCTEyOS41LDIyLjUgCSIvPgoJPHJlY3QgeD0iLTE1NS45IiB5PSItNTYuNyIgd2lkdGg9IjE0LjEiIGhlaWdodD0iMTEzLjQiLz4KCTxyZWN0IHg9Ii04Ny45IiB5PSItNTYuNyIgd2lkdGg9IjE0LjEiIGhlaWdodD0iMTEzLjQiLz4KCTxyZWN0IHg9Ii01Mi45IiB5PSItNTYuNyIgd2lkdGg9IjE0LjEiIGhlaWdodD0iMTEzLjQiLz4KCTxyZWN0IHg9IjE1LjEiIHk9Ii01Ni43IiB3aWR0aD0iMTQuMSIgaGVpZ2h0PSIxMTMuNCIvPgo8L3N5bWJvbD4KPHVzZSB4bGluazpocmVmPSIjSEhBX0JpbGRtYXJrZV9TY2h3YXJ6X1JHQi0yIiAgd2lkdGg9IjMxMS44IiBoZWlnaHQ9IjExMy40IiBpZD0iSEhBX0JpbGRtYXJrZV9TY2h3YXJ6X1JHQiIgeD0iLTE1NS45IiB5PSItNTYuNyIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAxNTUuOTA1IDU2LjY5NSkiIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPgo8L3N2Zz4K";
export { SvgHhaLogo as ReactComponent };